import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.step,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, { value: "default" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "d-flex align-center flex-shrink-0 flex-grow-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    label: "Rechercher",
                    "hide-details": "",
                    density: "compact",
                    clearable: "",
                    "append-inner-icon": "$search",
                    "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "d-flex align-center justify-end flex-shrink-1 flex-grow-0 pl-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {
                            _ctx.step = 'createUser';
                            _ctx.emitStepFromComponent();
                        }),
                    rounded: "xl",
                    elevation: "0",
                    size: "small",
                    "data-cy": "ThirdCompanyUsersEdition-add"
                  }, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createTextVNode(" Ajouter ")),
                      _createVNode(_component_v_icon, { right: "" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("$add")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.loading && _ctx.thirdPartyCompanyData)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                subheader: "",
                style: {"height":"40vh","overflow-y":"auto"}
              }, {
                default: _withCtx(() => [
                  (!_ctx.thirdPartyCompanyUsers.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Aucun resultat trouvé pour la recherche ")
                      ], 64))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartyCompanyUsers, (client, i) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: i,
                      onClick: ($event: any) => (_ctx.selectClient(client)),
                      class: _normalizeClass(_ctx.getClientClass(client.email)),
                      style: {"background":"#fff"},
                      "data-cy": 'selectInvoiceProduct-product-' + i,
                      lines: "two",
                      rounded: "xl",
                      border: ""
                    }, {
                      append: _withCtx(() => [
                        (!_ctx.showEditUsers)
                          ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                              key: 0,
                              icon: 
                                client.email === _ctx.selectedClient.email
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true),
                        (_ctx.showEditUsers)
                          ? (_openBlock(), _createBlock(_component_v_menu, {
                              key: 1,
                              "offset-y": ""
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_icon, _mergeProps({
                                  icon: "$dots_vertical",
                                  ref_for: true
                                }, props), null, 16)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      onClick: ($event: any) => (_ctx.editUser(client))
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode("$oss-edit")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Modifier")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_v_list_item, {
                                      onClick: ($event: any) => (_ctx.deleteUser(client))
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                                            _createTextVNode("$oss-trash")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createTextVNode("Supprimer")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(client.firstname) + " " + _toDisplayString(client.lastname), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode("E-mail: " + _toDisplayString(client.email) + " Téléphone: " + _toDisplayString(client.phoneNumber), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class", "data-cy"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" Vous n'avez aucun client enregistré ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {
                            _ctx.step = 'createUser';
                            _ctx.emitStepFromComponent();
                        }),
                          rounded: "xl",
                          elevation: "0",
                          dark: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _cache[18] || (_cache[18] = _createTextVNode(" Ajouter ")),
                            _createVNode(_component_v_icon, { right: "" }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("$add")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: "createUser" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            modelValue: _ctx.newUserValid,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUserValid) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.newUser.firstname,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.firstname) = $event)),
                        label: "Prénom",
                        "hide-details": "",
                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                        "data-cy": "ThirdCompanyUsersEdition-firstName",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pl-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.newUser.lastname,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.lastname) = $event)),
                        label: "Nom",
                        "hide-details": "",
                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                        "data-cy": "ThirdCompanyUsersEdition-lastName",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.newUser.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.email) = $event)),
                        label: "Adresse mail",
                        rules: [_ctx.rules.isEmail],
                        "data-cy": "ThirdCompanyUsersEdition-mail",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.newUser.phoneNumber,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.phoneNumber) = $event)),
                        label: "Téléphone",
                        "hide-details": "",
                        "data-cy": "ThirdCompanyUsersEdition-phone",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}